export const CDN_URL_NO_PROTO = "//93380217-10c9-4819-9112-bcd74f3cf5a1.selcdn.net";
export const CDN_URL = `https:${CDN_URL_NO_PROTO}`;
